import { OnInit, OnDestroy, Input, Component, AfterViewInit, Inject, Optional } from '@angular/core';
import { IContextService, PershingTranslationService, DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-portfolio-market',
    templateUrl: './dojo-portfolio-market.component.html'
})
export class DojoPortfolioMarketComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() showAsofdate: boolean = false;
    inputValue: string = '';
    domain: string = '';
    isEquipt: boolean = false;
    subs: Subscription;
    constructor(private contextService: IContextService, private translationService: PershingTranslationService,  @Optional() @Inject('AppSettings') appSettings: any) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
        if (appSettings.ibdConfigMap.community &&  appSettings.ibdConfigMap.community === 'equipt') {
            this.isEquipt = true;
        }
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            if (dojoApp) {
                // dojoApp.renderTradingOverview();
            }
        });
    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            // dojoApp.destroyWidget('tradingOverview');
        }
    }

    gotoRoute(page: string): void {
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
                'gotoPage': page
            }
        }));
    }
}
